import { Axios } from 'axios'

import { GsResponse, toGsResponse } from '../../goodstack'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { MarkAchievementAsViewedParams, MarkAchievementAsViewedResponse } from './markAchievementAsViewed.types'

export const markAchievementAsViewed: MutationFn<
  [MarkAchievementAsViewedParams],
  GsResponse<MarkAchievementAsViewedResponse>
> = async (client: Axios, [{ achievementId }]) =>
  client
    .put<{ success: true }>(
      `v1/account/account-achievements/${achievementId}/viewed`,
      {},
      {
        withCredentials: true,
        validateStatus: (_: number) => true
      }
    )
    .then(res => toGsResponse(res.status, res.data as any))
